"use client";

import { useMemo } from "react";

import { HomeDashboardTable } from "@/components/home-dashboard-table";
import { usePreloadDonor } from "@/hooks/useDonor";
import type { Donations } from "@/types/models/Donations";

import { getHomeLatestDonationsColumns } from "./homeLatestDonationsColumns";

type Props = {
  donations: Donations[];
  isLoading: boolean;
};

export function HomeLatestDonationsCard({ donations, isLoading }: Props) {
  const { preloadDonor } = usePreloadDonor();

  const columns = useMemo(
    () => getHomeLatestDonationsColumns(preloadDonor),
    [preloadDonor],
  );

  return (
    <HomeDashboardTable
      title="Latest donations"
      viewAllHref="/donations"
      columns={columns}
      data={donations}
      isLoading={isLoading}
      emptyMessage="No donations yet"
      getRowId={(row) => String(row.id)}
    />
  );
}
